import { type MediaType, isImage, isPDF, isVideo } from './mimeType';
import { MAX_IMAGE_SIZE, MAX_PDF_SIZE, MAX_VIDEO_SIZE } from './useMediaListManager';

export const getFileExtension = (filename: string) => {
  const extension = filename.includes('.') ? filename.split('.').pop() : undefined;

  return extension ? extension.toLowerCase() : undefined;
};

export const getFileTypeLabel = (filename: string, mediaType: MediaType) =>
  getFileExtension(filename) ?? mediaType.toLowerCase();

export const buildMaxSizeDescription = (mimeTypesWithComma?: string) => {
  const mimeStatus = {
    PDF: !mimeTypesWithComma,
    IMAGE: !mimeTypesWithComma,
    VIDEO: !mimeTypesWithComma,
  };

  const allMimeTypes = (mimeTypesWithComma || '').split(',').map((mime) => mime.trim());

  allMimeTypes.forEach((mime) => {
    if (!mimeStatus.PDF) {
      mimeStatus.PDF = isPDF(mime);
    }

    if (!mimeStatus.IMAGE) {
      mimeStatus.IMAGE = isImage(mime);
    }

    if (!mimeStatus.VIDEO) {
      mimeStatus.VIDEO = isVideo(mime);
    }
  });

  const maxSizes: string[] = [];

  if (mimeStatus.IMAGE) {
    maxSizes.push(`imagem ${MAX_IMAGE_SIZE}MB`);
  }

  if (mimeStatus.VIDEO) {
    maxSizes.push(`vídeo ${MAX_VIDEO_SIZE}MB`);
  }

  if (mimeStatus.PDF) {
    maxSizes.push(`PDF ${MAX_PDF_SIZE}MB`);
  }
  return maxSizes.join(', ');
};
